// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ListEventsAsAdminQueryVariables = PrivateSchemaTypes.Exact<{
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.EventModelAsAdminFilterInput> | PrivateSchemaTypes.EventModelAsAdminFilterInput>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  offset?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  order?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.OrderDescriptor> | PrivateSchemaTypes.OrderDescriptor>;
}>;


export type ListEventsAsAdminQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id' | 'eventsCount'>
      & { events: Array<(
        { __typename?: 'EventModelAsAdmin' }
        & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'title' | 'start_time' | 'end_time' | 'location' | 'timezone' | 'inviteesCount' | 'attendeesCount' | 'is_open' | 'presentCount' | 'published_date' | 'recurring_event_id'>
        & { tags: Array<(
          { __typename?: 'TagModel' }
          & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
        )>, recurringEvent?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'RecurringEventModelAsStudent' }
          & Pick<PrivateSchemaTypes.RecurringEventModelAsStudent, 'id'>
          & { recurrence?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'EventRecurrencePattern' }
            & Pick<PrivateSchemaTypes.EventRecurrencePattern, 'interval' | 'count' | 'byDay' | 'freq'>
          )> }
        )> }
      )> }
    )> }
  )>, me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id' | 'timezone'>
  ) }
);


export const ListEventsAsAdminDocument = gql`
    query listEventsAsAdmin($filters: [EventModelAsAdminFilterInput!], $limit: NonNegativeInt, $offset: NonNegativeInt, $order: [OrderDescriptor!]) {
  admin {
    organisation {
      id
      events(filters: $filters, limit: $limit, offset: $offset, order: $order) {
        id
        title
        start_time
        end_time
        location
        timezone
        inviteesCount
        attendeesCount
        is_open
        presentCount
        published_date
        recurring_event_id
        tags {
          id
          name
        }
        recurringEvent {
          id
          recurrence {
            interval
            count
            byDay
            freq
          }
        }
      }
      eventsCount(filters: $filters)
    }
  }
  me {
    id
    timezone
  }
}
    `;

/**
 * __useListEventsAsAdminQuery__
 *
 * To run a query within a React component, call `useListEventsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventsAsAdminQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEventsAsAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListEventsAsAdminQuery, ListEventsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListEventsAsAdminQuery, ListEventsAsAdminQueryVariables>(ListEventsAsAdminDocument, options);
      }
export function useListEventsAsAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListEventsAsAdminQuery, ListEventsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListEventsAsAdminQuery, ListEventsAsAdminQueryVariables>(ListEventsAsAdminDocument, options);
        }
export type ListEventsAsAdminQueryHookResult = ReturnType<typeof useListEventsAsAdminQuery>;
export type ListEventsAsAdminLazyQueryHookResult = ReturnType<typeof useListEventsAsAdminLazyQuery>;
export type ListEventsAsAdminQueryResult = Apollo.QueryResult<ListEventsAsAdminQuery, ListEventsAsAdminQueryVariables>;